import React, { useState } from "react";
import { ReactComponent as IconQuestionMark } from "../../assets/icon-question-mark.svg";
import { Modal } from "react-bootstrap";
import classes from "./Tooltip.module.scss";

interface Props {
  children: React.ReactNode;
}

function Tooltip({ children }: Props) {
  const [show, setShow] = useState<boolean>(false);

  const handleShow = () => setShow(true);
  const handleClose = (event?: React.MouseEvent) => {
    event?.preventDefault();
    setShow(false);
  };

  return (
    <>
      <IconQuestionMark
        className={`flex-shrink-0 ms-2 ${classes.icon}`}
        onClick={handleShow}
      />

      <Modal show={show} onHide={handleClose} centered className={classes.modal}>
        <Modal.Body className={"text-center"}>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          ></button>
          <p>
            <IconQuestionMark className={classes.modalIcon} />
          </p>
          <p>{children}</p>
          <p className={"mb-lg-0"}>
            <a href={"#"} onClick={handleClose} className={"link transparent"}>
              Close window
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Tooltip;
